import { CustomError } from 'ts-custom-error';

export class EmbedError extends CustomError {
  constructor(message?: string, options?: ErrorOptions) {
    super(message, options);
  }
}
